import type { Button, ButtonProps, GetRef } from 'antd';
import { forwardRef } from 'react';
import { StyledButton } from './components/StyledButton';

type ButtonRef = GetRef<typeof Button>;

export interface ButtonAntProps
  extends Pick<
    ButtonProps,
    | 'id'
    | 'type'
    | 'size'
    | 'children'
    | 'htmlType'
    | 'disabled'
    | 'loading'
    | 'icon'
    | 'onClick'
    | 'style'
    | 'form'
    | 'block'
    | 'danger'
    | 'ghost'
    | 'href'
    | 'target'
    | 'itemRef'
    | 'shape'
    | 'onMouseEnter'
    | 'onMouseLeave'
    | 'aria-label'
    | 'iconPosition'
  > {
  'data-cy'?: string;
}

export const ButtonAnt = forwardRef<ButtonRef, ButtonAntProps>((props, ref) => {
  return <StyledButton ref={ref} {...props} />;
});
